import React, { useEffect, useMemo } from 'react';
import { useRootStore } from 'store';
import {
  TablePaginatedV8,
  CellLeftV8,
  EditCellV8,
  CellFloatCustomV8,
  TableCellV8,
} from 'motion-components';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import { useFormikContext } from 'formik';
// import { TablePaginatedV8 } from 'table-v8/table-paginated-v8';

/* ----------- Component ------------------ */
export const IDocExtrasTable = ({ idocId, data, canEdit }) => {
  const location = useLocation<any>();
  const history = useHistory();
  const { appStore, tableStore } = useRootStore();
  const { t, i18n } = useTranslation();
  const { values, setFieldValue, isSubmitting, dirty } = useFormikContext<any>();

  const columns = useMemo(
    () => [
      {
        id: 'containertype.name',
        header: t('Τύπος Συσκευασίας'),
        columnName: t('Τύπος Συσκευασίας'),
        accessorKey: 'containertype.name',
        orderByField: 'containertype.name',
        cell: CellLeftV8,
        size: 5,
      },
      {
        id: 'containersQty',
        header: t('Πλήθος Συσκευασιών'),
        columnName: t('Πλήθος Συσκευασιών'),
        accessorKey: 'containersQty',
        orderByField: 'containersQty',
        cell: TableCellV8,
        meta: { type: 'float', noEnter: true },
        size: 30,
      },
      {
        id: 'containerTareWeight',
        header: t('Απόβαρο Συσκευασίας'),
        columnName: t('Απόβαρο Συσκευασίας'),
        accessorKey: 'containerTareWeight',
        orderByField: 'containerTareWeight',
        cell: TableCellV8,
        meta: { type: 'float', noEnter: true },
        size: 30,
      },
      {
        id: 'edit',
        header: t('Ενέργειες'),
        columnName: t('Ενέργειες'),
        accessorKey: 'edit',
        orderByField: 'lastUser',
        size: 120,
        cell: (props: any) => {
          const { row, table } = props;
          return canEdit ? EditCellV8({ row, table }) : <div className="text-center">-</div>;
        },
      },
    ],
    [],
  );

  // const tableRef = useRef('aaa');
  // // // return of useRef
  // useImperativeHandle(ref, () => (tableRef.current ? tableRef.current : null));

  const onSaveRow = async (rowIndex, row, changes) => {
    //
    // i.e. Save Record
    //

    let id = row.id;

    // Κράτα αντίγραφο των κάδων
    let lcIdocExtras = JSON.parse(JSON.stringify(values.idocExtras));
    console.log('$$$values.idocExtras= ', values.idocExtras);
    console.log('$$$lcIdocExtras= ', lcIdocExtras);
    // Ενημέρωσε τις Τιμές του Formik
    if (changes.containertypeId) {
      setFieldValue(`idocExtras[${rowIndex}].containertypeId`, changes.containertypeId);
      lcIdocExtras[rowIndex].containertypeId = changes.containertypeId;
    } else {
      // setFieldValue(`idocExtras[${rowIndex}].containertypeId`, null);
      // lcIdocExtras[rowIndex].containertypeId = 0;
    }
    if (changes.containersQty !== undefined) {
      setFieldValue(`idocExtras[${rowIndex}].containersQty`, changes.containersQty);
      lcIdocExtras[rowIndex].containersQty = changes.containersQty;
    } else {
      // Preserve the existing value instead of setting it to null
      lcIdocExtras[rowIndex].containersQty = values.idocExtras[rowIndex].containersQty || 0;
    }
    if (changes.containerTareWeight !== undefined) {
      const tareWeight = parseFloat(changes.containerTareWeight) || 0;
      setFieldValue(`idocExtras[${rowIndex}].containerTareWeight`, tareWeight);
      lcIdocExtras[rowIndex].containerTareWeight = tareWeight;
    } else {
      // Preserve the existing value instead of setting it to null
      lcIdocExtras[rowIndex].containerTareWeight =
        values.idocExtras[rowIndex].containerTareWeight || 0;
    }

    // Υπολόγισε Άθροισμα Κάδων και Απόβαρου
    let sumContQty = 0;
    let sumContTareWeight = 0;
    for (let index = 0; index < lcIdocExtras.length; index++) {
      const element = lcIdocExtras[index];
      const qty = Number.isFinite(Number(element.containersQty))
        ? Number(element.containersQty)
        : 0;
      const tare = Number.isFinite(Number(element.containerTareWeight))
        ? Number(element.containerTareWeight)
        : 0;
      console.log('$$$$ qty tare', qty, tare, element.containerTareWeight);
      console.log(`Index ${index} -> Qty: ${qty}, Tare: ${tare}, Partial Weight: ${qty * tare}`);
      sumContQty = sumContQty + qty;
      sumContTareWeight += qty * tare;
      console.log(
        `Index ${index} -> Qty: ${qty}, Tare: ${tare}, Running Total: ${sumContTareWeight}`,
      );
    }
    // Ενημέρωσε Αθροίσματα στο Header
    console.log('$$$sumContTareWeight= ', sumContTareWeight);
    setFieldValue('containersQty', sumContQty);
    setFieldValue('tareWeight', sumContTareWeight);

    //return id;
    return true; // για να γυρίσει σε browse ο πίνακας
  };

  return (
    <>
      <h5 className="form-group-title" style={{ marginBottom: '0px' }}>
        {t('Πρόσθετα Στοιχεία Συσκευασιών')}
      </h5>

      {/* TableGrid */}
      {data ? (
        <TablePaginatedV8
          // ref={tableRef}
          loading={false}
          id="containers-grid"
          appStore={appStore}
          tableStore={tableStore}
          key="grid"
          columns={columns as any}
          data={data}
          dataCount={data.length}
          topBorderRadius={false}
          initSorting={[{ id: 'containertype.name', desc: true }]}
          onSaveRow={onSaveRow}
        />
      ) : (
        <div style={{ height: '200px' }}></div>
      )}
    </>
  );
};

